import flagArgentina from '../../assets/flags/flag-argentina.png';
import flagBrazil from '../../assets/flags/flag-brazil.png';
import { DEFAULT_COUNTRY_CODE, type CountryCode } from '../config';

export { DEFAULT_COUNTRY_CODE, type CountryCode } from '../config';

export const BRAZIL_PHONE_MASK = '(00) 00000-0000';
export const ARGENTINA_PHONE_MASK = '9 000 000-0000';
export const PHONE_DIGITS_COUNT = 11;

export type NormalizedPhoneInput = {
  countryCode: CountryCode;
  phoneDigits: string;
};

export type CountryOption = {
  value: CountryCode;
  flag: string;
  mask: string;
};

const BRAZIL_COUNTRY_OPTION: CountryOption = {
  value: '+55',
  flag: flagBrazil,
  mask: BRAZIL_PHONE_MASK,
};
const ARGENTINA_COUNTRY_OPTION: CountryOption = {
  value: '+54',
  flag: flagArgentina,
  mask: ARGENTINA_PHONE_MASK,
};

export const COUNTRY_OPTIONS = [
  BRAZIL_COUNTRY_OPTION,
  ARGENTINA_COUNTRY_OPTION,
] as const satisfies ReadonlyArray<CountryOption>;

const COUNTRY_OPTION_BY_CODE: Record<CountryCode, CountryOption> = {
  '+54': ARGENTINA_COUNTRY_OPTION,
  '+55': BRAZIL_COUNTRY_OPTION,
};

export function sanitizePhoneDigits(value: string) {
  return value.replace(/\D/g, '').slice(0, PHONE_DIGITS_COUNT);
}

function resolveCountryCodeDigits(countryCode: CountryCode) {
  return countryCode.replace(/\D/g, '');
}

export function normalizePhoneInput(
  value: string,
  fallbackCountryCode: CountryCode = DEFAULT_COUNTRY_CODE,
): NormalizedPhoneInput {
  const phoneDigits = value.replace(/\D/g, '');
  const nextCountryCode = fallbackCountryCode;
  const nextCountryCodeDigits = resolveCountryCodeDigits(nextCountryCode);
  const nextPhoneDigits =
    phoneDigits.length > PHONE_DIGITS_COUNT &&
    phoneDigits.startsWith(nextCountryCodeDigits)
      ? phoneDigits.slice(nextCountryCodeDigits.length)
      : phoneDigits;

  return {
    countryCode: nextCountryCode,
    phoneDigits: nextPhoneDigits.slice(0, PHONE_DIGITS_COUNT),
  };
}

export function resolveCountryOption(countryCode: CountryCode): CountryOption {
  return COUNTRY_OPTION_BY_CODE[countryCode];
}

export function isPhoneLengthComplete(phoneDigitsLength: number): boolean {
  return phoneDigitsLength === PHONE_DIGITS_COUNT;
}

export function formatPhoneByMask(
  phoneDigits: string,
  countryCode: CountryCode = DEFAULT_COUNTRY_CODE,
) {
  const normalizedDigits = sanitizePhoneDigits(phoneDigits);
  const phoneMask = resolveCountryOption(countryCode).mask;
  let digitsIndex = 0;
  let maskedValue = '';

  for (const maskSymbol of phoneMask) {
    if (maskSymbol === '0') {
      if (digitsIndex >= normalizedDigits.length) {
        break;
      }

      maskedValue += normalizedDigits[digitsIndex];
      digitsIndex += 1;
      continue;
    }

    if (digitsIndex < normalizedDigits.length) {
      maskedValue += maskSymbol;
    }
  }

  return maskedValue;
}
